import styled from "styled-components";
// import { Link } from "react-router-dom";

export const FooterContainer = styled.footer`
  background-color: #101522;
`;

export const FooterWrap = styled.div`
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
`;

export const FooterTextContainer = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 820px) {
    padding-top: 32px;
  }
`;

export const FooterTextWrapper = styled.div`
  display: flex;
  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const FooterItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 6px;
  // left:20px
  text-align: center;
  width: 160px;
  box-sizing: border-box;
  color: #fff;

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

export const FooterTextTitle = styled.h1`
  font-size: 24px;
  margin-bottom: 16px;
`;

export const FooterText = styled.div`
  color: #fff;
  margin-bottom: 1.5rem;
  font-size: 14px;
  width: 300px;
`;

export const SocialMedia = styled.div`
  max-width: 1000%;
  width: 100%;
`;
export const SocialMediaWrap = styled.div`
  display: flex;

  // position: absolute;
  align-items: center;

  max-width: 1100px;
  margin: 40px auto 0 auto;
  flex-direction: column;
  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const SocialMediaText = styled.h1`
  // position: relative;
  font-size: 24px;
  margin-bottom: 10px;
  color: #fff;
  padding: 5px;
  display: flex;
  margin: 20px;
  text-align: right;
`;

export const WebsiteRights = styled.small`
  color: #fff;
  margin-bottom: 18px;
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 220px;
  padding: -50px;
  margin: 16px;
`;

export const SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;
`;
